/*
 * @Description: vue router
 * @Date: 2019-11-26
 */

// Import routes
import Vue from 'vue'
import VueRouter from 'vue-router'

import generateRoutes from './generateRoutes'

import Observable from "@src/observable";

export default async function({ configuration }) {
  Vue.use(VueRouter)

  const routes = await generateRoutes({ configuration })

  const router = new VueRouter({
    mode: 'history',
    base: process.env.VUE_APP_RELEASE_FLODER_PATH,
    routes: routes,
    scrollBehavior: () => ({ x: 0, y: 0 })
  })

  router.beforeEach(async (to, from, next) => {
    // set title
    // document.title = to.meta?.title ?? window.configuration.application.title
    Observable.mutations.setIfSupportWebp(document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') == 0)
    next()
  })

  return router
}
